import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { StoresContext } from '@App/contexts'
import MainPreloaderOverlay from '@Components/Preloaders/MainPreloader/MainPreloaderOverlay'

/**
 * Displays an opaque loading spinner when open that overlays the whole page.
 *
 * Should only be used when switching between major sections of the app, for example
 * when logging in, or switching between Member Hub and Songwriter Hub
 */
const MainPreloader = () => {
    const { preloaderStore } = useContext(StoresContext)

    return preloaderStore.mainPreloaderIsOpen ? <MainPreloaderOverlay /> : null
}

export default observer(MainPreloader)
